// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.feedtomanual.RentalManagerUserPropertyFeedToManualWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyFeedToManualConvertAllResponseWebDto,
  UserPropertyFeedToManualConvertResponseWebDto,
  UserPropertyFeedToManualStatusesResponseWebDto,
} from '../..';

interface ConvertParams {
  bypassManualDupeRestriction?: boolean;
  keepExistingListingIdentifiers?: boolean;
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Path =
  '/api/web/v1/users/properties/feedToManual/convert';

/**
 * Convert a feed listing to manual listing
 */
export const RentalManagerUserPropertyFeedToManualWebApiHandler_convert = (
  getParams: ConvertParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ConvertParams, never, UserPropertyFeedToManualConvertResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFeedToManualWebApiHandler_convert_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll_Path =
  '/api/web/v1/users/properties/feedToManual/convertAll';

/**
 * Convert all convertible feed listings to manual listings
 */
export const RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserPropertyFeedToManualConvertAllResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyFeedToManualWebApiHandler_convertAll_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_Path =
  '/api/web/v1/users/properties/feedToManual/statuses';

/**
 * Statuses of feed listing to manual listing conversions
 */
export const RentalManagerUserPropertyFeedToManualWebApiHandler_statuses = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserPropertyFeedToManualStatusesResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyFeedToManualWebApiHandler_statuses_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
